module.exports = __webpack_public_path__ + "static/media/vacctrak_logo_blue.a85f9583.svg";